import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'demoozDateToString'
})
export class DemoozDateToStringPipe implements PipeTransform {

    constructor(){}

    transform(value: unknown, ...args: unknown[]): string {
        let dateStr = '';
        let format = args[0]?.toString() || 'DD/MM/YYYY';
        if(value && value instanceof Date){
            if(format === 'ISO8601'){
                dateStr = moment(value).format();  
            }
            else{                
                dateStr = moment(value).format(format);  
            }          
        }
        return dateStr;
    }

}
